import { Schema } from 'effect';
import { BillingInterval, CentAmount, PlanKey } from './billing-status';
import { CheckoutAttribution, ConfirmationType } from './billing-subscribe';

export const AnalyticsDistinctId = Schema.String.check(
  Schema.isMaxLength(200),
  Schema.isPattern(/^[\w.:$-]+$/),
);

export const PendingCheckoutQuoteQuery = Schema.Struct({
  distinct_id: Schema.optional(AnalyticsDistinctId),
});

export const CreatePendingCheckoutRequest = Schema.Struct({
  plan_id: PlanKey,
  expected_amount_cents: CentAmount,
  cf_turnstile_token: Schema.String,
  attribution: Schema.optional(CheckoutAttribution),
});
export type CreatePendingCheckoutRequest =
  typeof CreatePendingCheckoutRequest.Type;

export const CreatePendingCheckoutResponse = Schema.Struct({
  client_secret: Schema.String,
});
export type CreatePendingCheckoutResponse =
  typeof CreatePendingCheckoutResponse.Type;

export const PendingCheckoutCard = Schema.Struct({
  brand: Schema.String,
  last4: Schema.String,
});

export const PendingCheckoutState = Schema.Literals([
  'none',
  'awaiting_card',
  'card_saved',
]);
export type PendingCheckoutState = typeof PendingCheckoutState.Type;

export const PendingCheckoutStatus = Schema.Struct({
  state: PendingCheckoutState,
  setup_intent_id: Schema.NullOr(Schema.String),
  plan_id: Schema.NullOr(PlanKey),
  interval: Schema.NullOr(BillingInterval),
  amount_cents: Schema.NullOr(CentAmount),
  trial_days: Schema.NullOr(Schema.Int),
  card: Schema.NullOr(PendingCheckoutCard),
});
export type PendingCheckoutStatus = typeof PendingCheckoutStatus.Type;

export const FinishPendingCheckoutOutcome = Schema.Literals([
  'created',
  'already_subscribed',
  'offer_unavailable',
  'no_pending_checkout',
]);
export type FinishPendingCheckoutOutcome =
  typeof FinishPendingCheckoutOutcome.Type;

export const FinishPendingCheckoutResponse = Schema.Struct({
  outcome: FinishPendingCheckoutOutcome,
  setup_intent_id: Schema.NullOr(Schema.String),
  subscription_id: Schema.NullOr(Schema.String),
  client_secret: Schema.NullOr(Schema.String),
  confirmation_type: Schema.NullOr(ConfirmationType),
});
export type FinishPendingCheckoutResponse =
  typeof FinishPendingCheckoutResponse.Type;
